import { render, staticRenderFns } from "./TentativeReservedVisitor.vue?vue&type=template&id=2a78c4f5&scoped=true"
import script from "./TentativeReservedVisitor.vue?vue&type=script&lang=js"
export * from "./TentativeReservedVisitor.vue?vue&type=script&lang=js"
import style0 from "./TentativeReservedVisitor.vue?vue&type=style&index=0&id=2a78c4f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a78c4f5",
  null
  
)

export default component.exports